import React from 'react'
import Layout from '../DashboardLayout'

const TransmitDrafts = () => {
  return (
    <Layout>TransmitDrafts</Layout>
  )
}

export default TransmitDrafts